import { render, staticRenderFns } from "./select-group.vue?vue&type=template&id=183030db"
import script from "./select-group.vue?vue&type=script&lang=js"
export * from "./select-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports